import { alertCloseService } from '../services'

const alertClose = (alertId, formData) => {
	return new Promise(resolve => {
		alertCloseService.save(alertId, formData)
			.then(response => {
				resolve({ success: true, data: response.data })
			})
	})
}
export default alertClose